import { takeEvery, fork, put, all, call } from "redux-saga/effects";

// Channels Redux States
import {
  GET_CHANNELS,
  GET_CHANNEL,
  CREATE_CHANNEL,
  EDIT_CHANNEL,
  DELETE_CHANNEL,
} from "./actionTypes";
import {
  setChannels,
  apiError,
  setChannel,
  createChannelSuccess,
  editChannelSuccess,
  deleteChannelSuccess,
} from "./actions";

//Include Both Helper File with needed methods
import axios from "axios";

function* getChannels({ payload: { page, qnt, name } }) {
  try {
    const response = yield call(
      axios.get,
      `/source?${
        (page ? `page=${page}` : "") +
        (qnt ? `&qtd=${qnt}` : "") +
        (name ? `&name=${name}` : "") 
      }`
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setChannels(response.data.data, qnt));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          //TODO: remover esta verificação quando o backend enviar array vazio com status 200 quando nao ha objetos
          if (error.response.data && typeof error.response.data === "object") {
            message = error.response.data.message;
          } else {
            message = "Sorry! the page you are looking for could not be found";
          }
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* createChannel({ payload: { newChannelValues } }) {
  try {
    const response = yield call(axios.post, `/source`, newChannelValues);
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message;
      yield put(createChannelSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}

function* getChannel({ payload: { idChannel, isForm } }) {
  try {
    const response = yield call(
      axios.get,
      `/source?${
        (idChannel ? `id=${idChannel}` : "") + (isForm ? `&form=${isForm}` : "")
      }`,
      {}
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.data
    ) {
      yield put(setChannel(response.data.data));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* editChannel({ payload: { idChannel, newChannelValues } }) {
  try {
    const response = yield call(
      axios.patch,
      `/source?${idChannel ? `id=${idChannel}` : ""}`,
      newChannelValues
    );
    if (
      (response.status >= 200 || response.status <= 299) &&
      response.data &&
      response.data.message
    ) {
      let message = response.data.message;
      yield put(editChannelSuccess(message));
    } else throw response.data;
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
function* deleteChannel({ payload: { idChannel } }) {
  try {
    const response = yield call(
      axios.delete,
      `/source${idChannel ? `?id=${idChannel}` : ""}`
    );
    if (response.status >= 200 || response.status <= 299) {
      let message = response.data.message ? response.data.message : "";
      yield put(deleteChannelSuccess(message));
    } else {
      throw response.data;
    }
  } catch (error) {
    let message;
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 401:
          message = "Invalid credentials";
          break;
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message =
            "Sorry! something went wrong, please contact our support team";
          break;
        default:
          if (error.response.data && error.response.data.message)
            message = error.response.data.message;
          else message = error.message;
          break;
      }
    }
    yield put(apiError(message));
  }
}
export function* watchChannel() {
  yield takeEvery(GET_CHANNELS, getChannels);
}
export function* watchGetChannel() {
  yield takeEvery(GET_CHANNEL, getChannel);
}
export function* watchCreateChannel() {
  yield takeEvery(CREATE_CHANNEL, createChannel);
}
export function* watchEditChannel() {
  yield takeEvery(EDIT_CHANNEL, editChannel);
}
export function* watchDeleteChannel() {
  yield takeEvery(DELETE_CHANNEL, deleteChannel);
}
function* authSaga() {
  yield all([
    fork(watchChannel),
    fork(watchGetChannel),
    fork(watchCreateChannel),
    fork(watchEditChannel),
    fork(watchDeleteChannel),
  ]);
}

export default authSaga;
